    import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ProjectInfoContent from '../components/ProjectInfoContent'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';
import PageHeader from '../components/PageHeader'; 
import {api_base_url, base_url} from '../common/Constants'; 
import { Helmet } from "react-helmet";

class ProjectInfo extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            project:[]
        }
    }

    componentDidMount()
    {
        var data = { id : this.props.params.id} 
            axios.post(api_base_url+"project", data).then(response=>{
                this.setState({project:response.data}); 
                this.setState({loading:0});
            }); 
    }
 
    render()
    {

        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/>
                <Helmet>
                    <title>{this.state.project.title+" - "+metas[0].title}</title>  
                    <meta name="description" content={this.state.project.meta_description} />
                    <meta name="keywords" content={this.state.project.meta_title} />
                    <meta property="og:image" content={this.state.project.image}  />
                    <link rel="canonical" href={base_url+'project-info/'+this.state.project.slug} />
                </Helmet> 
                <PageHeader title={this.state.project.title}/>
                <ProjectInfoContent slug={this.props.params.id}  title={this.state.project.title} project={this.state.project} />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(ProjectInfo);